import {cashBoxViewPage} from "../../../hoc/cashBoxViewPage";

const CashOut = cashBoxViewPage("CashOut")

export default CashOut
